import { useEffect, useState } from "react";
const baseUrl = process.env.REACT_APP_API_BASE_URL

const useOrganizationalStructure = () => {
    const [chartUrl, setChartUrl] = useState(null);
    const [lastUpdated, setLastUpdated] = useState(null);
    const [loadingOrganizational, setLoadingOrganizational] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchChart = async () => {
            if (!baseUrl) {
                setError("REACT_APP_API_BASE_URL tidak ditemukan");
                setLoadingOrganizational(false);
                return;
            }

            try {
                const res = await fetch(
                    `${baseUrl}organizational-structure/read-published`
                );

                if (!res.ok) {
                    throw new Error("Gagal fetch struktur organisasi");
                }

                const data = await res.json();
                const firstItem = data?.[0];

                if (!firstItem || !firstItem.chart) {
                    throw new Error("Struktur organisasi tidak tersedia");
                }

                setChartUrl(firstItem.chart);
                setLastUpdated(firstItem.last_updated);
                setLoadingOrganizational(false);
            } catch (err) {
                setError(
                    err.message ||
                        "Terjadi kesalahan saat fetch struktur organisasi"
                );
                setLoadingOrganizational(false);
            }
        };

        fetchChart();
    }, []);

    return {
        chartUrl,
        lastUpdated,
        loadingOrganizational,
        error,
    };
};

export default useOrganizationalStructure;
